<div class="beneficiary-selection d-flex flex-column justify-content-between receiver-phone-number container p-4">
    <div class="d-flex justify-content-start align-items-center" (click)="backToTransferMoney()">
        <mat-icon fontIcon="arrow_back"></mat-icon>
        <span>Back</span>
    </div>

    <div class="my-4">
        <h2>Enter receiver's phone number</h2>
        <p>Enter the receiver's phone number or select from your beneficiaries.</p>
    </div>

    <div class="phone-number">
        <div class="phone-number-input d-flex align-items-center mt-4">
            <ngx-mat-intl-tel-input
                [enablePlaceholder]="true"
                [enableSearch]="allowedCountriesInPhoneSearch.length > 0 ? false : true"
                [onlyCountries]="allowedCountriesInPhoneSearch"
                [searchPlaceholder]="'Search country..'"
                class="w-100"
                [formControl]="mobileControl"
                name="mobile"
            />
        </div>
        <div class="m-2">
            <div *ngIf="mobileControl.hasError('required') && (mobileControl.touched || mobileControl.dirty)" class="error-msg">
                <mat-icon class="errorIcon" fontIcon="error" />
                Phone number is required.
            </div>
            <div *ngIf="mobileControl.hasError('validatePhoneNumber') && (mobileControl.touched || mobileControl.dirty)" class="error-msg">
                <mat-icon class="errorIcon" fontIcon="error" />
                Phone number is invalid.
            </div>
            <div *ngIf="mobileControl.hasError('pattern') && (mobileControl.touched || mobileControl.dirty)" class="error-msg">
                <mat-icon class="errorIcon" fontIcon="error" />
                Please enter a valid phone number.
            </div>
        </div>
    </div>

    <!-- <div class="beneficiaries my-2">
        <h5 class="my-2">Recipient</h5>

        <div *ngFor="let transactions of [1, 2, 3, 4, 5]">
            <div class="transaction-container">
                <div>
                    <mat-icon svgIcon="user-img" class="profile-pic"></mat-icon>
                </div>

                <div class="transaction-details">
                    <h6 class="mb-0">Henry Montealegre</h6>
                    <p class="text-sub mb-0">+249 55 123 4567</p>
                </div>

                <div class="transactions-currency d-flex justify-content-center align-items-center py-1 px-2">
                    <img src="../../../../../assets/home/united states.svg" class="flag-icon me-1" />
                    <div class="transaction-credit">USD</div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="footer d-flex justify-content-start align-items-center mt-4">
        <button
            mat-raised-button
            class="btn-primary rounded-pill me-2"
            (click)="continueToPeerToPeerTransaction()"
            [class.btn-primary-disabled]="mobileControl.invalid || !mobileControl.dirty"
            [class.button-spinner]="loading"
            [disabled]="mobileControl.invalid || !mobileControl.dirty || loading"
        >
            {{ loading ? '' : 'Continue' }}
        </button>
        <button mat-raised-button class="btn-secondary rounded-pill" (click)="backToTransferMoney()">Cancel</button>
    </div>
</div>
